<script>
  import UserAvatar from '../../lib/components/UserAvatar.svelte';
  import { t9n } from '../../lib/translate';
  import { TS } from '../../config/translation-keys';

  // component options  ------------------------------------------------------ //

  export let role;
  export let comment;

  let menu_no_content = t9n(TS.PROFILE_NO_MESSAGE);
</script>

<article class="row {`comment-item ${role}`}">
  <div class="column-comment">
    <div class="comment-message">

      <div id="container" class="comment-message-header">
        <UserAvatar
          url={comment.avatar_url}
          options={{ style: 'width: 30px; height: 30px; border-radius: 50%;' }} />
        <!--        <img src={comment.avatar_url} alt="avatar" class="comment-avatar" />-->
        <div class="line-solver">
          <span style="vertical-align: middle" class="name-text">{comment.display_name}</span>
        </div>
        <div class="rating-block">
          <img class="comment-rate img-circle" src={comment.rating_image_url} alt="" />
        </div>

      </div>

      <!--      <div class="comment-message-header">-->
      <!--        <img src={comment.avatar_url} alt="avatar" class="comment-avatar">-->
      <!--        <span>{comment.display_name}</span>-->
      <!--        <img class="comment-rate img-circle" src={comment.rating_image_url} alt="">-->
      <!--      </div>-->
      <div class="comment-message-content">
        {#if comment.message === 'no message'}
          <p style="color: grey;">{menu_no_content}</p>
        {:else}
          <p>{comment.message}</p>
        {/if}
      </div>
    </div>
  </div>
  <div class="column-checker">
    <div class="center">
      <span class="comment-icon">
        <i class="material-icons">done</i>
      </span>
    </div>
  </div>
  <div class="column-date">
    <div class="date-margin">
      <span class="comment-date">{comment.display_date}</span>
    </div>
  </div>
</article>

<style>
  /* Actual comment look
  ************************/

  .comment-message {
    background: white;
    border-radius: 5px;
    -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  }

  .comment-message-header {
    height: 30px;
    padding: 10px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    display: flex;
    justify-content: space-between;
  }

  .orderer .comment-message-header {
    background-color: var(--orderer-background-color);
    color: var(--orderer-foreground-color);
  }

  .worker .comment-message-header {
    background-color: var(--worker-background-color);
    color: var(--worker-foreground-color);
  }

  .comment-message-content {
    margin-top: -13px;
    min-height: 50px;
    padding: 10px;
    font-size: 14px;
    overflow-x: hidden;
    word-break: break-all;
  }

  .comment-icon {
    margin-top: -5px;
    color: white;
  }

  .comment-date {
    margin-top: -2px;
    color: #444;
  }

  .orderer .comment-icon .material-icons {
    background-color: var(--orderer-background-color);
  }

  .worker .comment-icon .material-icons {
    background-color: var(--worker-background-color);
  }

  .comment-avatar,
  .comment-rate {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }

  .comment-rate {
    float: right;
  }

  /* The 3 column grid stuff
  *****************************/

  .center {
    text-align: center;
  }

  .date-margin {
    margin-top: 5px;
  }

  .column-comment {
    float: left;
    width: 33.33%;
    padding: 10px;
  }

  .column-checker {
    float: left;
    width: 10%;
    padding: 10px;
  }

  .column-date {
    float: left;
    width: 33.33%;
    padding: 10px;
  }

  .row {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .row:nth-child(even) {
    direction: rtl;
  }

  .row:nth-child(even) .comment-message {
    text-align: left;
  }

  .row:nth-child(even) .date-margin {
    text-align: right;
    direction: ltr;
  }

  .row:nth-child(even) p {direction: ltr;}

  .comment-message span,
  .comment-message img {
    /*display: flex;*/
    /*display: inline-block;*/
  }

  .name-text {
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-content: center;*/
    /*flex-direction: column;*/
    /*overflow-x: hidden;*/
    /*padding: 0 5px;*/
    /*!*scrollbar-width: none;*!*/
    /*direction: ltr;*/
    /*line-height: 27px;*/
    padding: 0 5px;
    line-height: 16px;
    text-align: center;
    display: inline-block;
    vertical-align: middle;
  }

  .line-solver {
    height: 33px;
    overflow: auto;
    word-break: break-all;
    line-height: 24px;
    direction: ltr;
  }

  /* Mobile Mode
  ************************************/
  @media screen and (max-width: 768px) {
    .column-checker {
      /* width: 5%; */
    }

    .column-comment {
      width: 100%;
    }
  }

  @media (min-width: 0) and (max-width: 400px) {
    .column-checker {
      display: none;
    }
  }
</style>
